import React from "react";
import { Button } from "@components/ui/button";
import { Card, CardContent, CardTitle } from "@components/ui/card";
import type { PaymentSetupViewProps } from "@ps-bridge/contracts/paymentSetup";
import type { Ok } from "@ps-bridge/ok";
import * as Option from "@utils/Option";
import * as styles from "@styles/Payment.css";

type PaymentSetupMissingSecretContractProps = Pick<PaymentSetupViewProps, never>;

type PaymentSetupMissingSecretViewProps = PaymentSetupMissingSecretContractProps & {
  onBack: () => Ok;
};

const PaymentSetupMissingSecretView: React.FC<PaymentSetupMissingSecretViewProps> = ({
  onBack,
}) => (
  <div className={styles.container} data-testid="payment-setup-missing-secret">
    <Card className={styles.card}>
      <CardContent>
        <CardTitle className={styles.title}>Payment setup unavailable</CardTitle>
        <p className={styles.subtitle}>
          Missing setup intent. Return to subscription selection and try again.
        </p>
        <Button data-testid="payment-setup-back" onClick={onBack} asChild={Option.none()}>
          Back to subscription selection
        </Button>
      </CardContent>
    </Card>
  </div>
);

export default PaymentSetupMissingSecretView;
